import React from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useLiffProfile } from "../../context/LiffProfileContext";

const ScreenSizeBar = ({ seniorLayout, onChangeSeniorLayout }) => {
  const { authToken, userId, profile } = useLiffProfile();
  const { t, i18n } = useTranslation();

  const toggleSeniorLayout = async (e) => {
    e.preventDefault();
    const newLayout = !seniorLayout;

    try {
      await updateCurrentUser({ seniorLayout: newLayout });
      localStorage.setItem("seniorLayout", newLayout ? "true" : "false");

      onChangeSeniorLayout(newLayout); // <-- ส่งค่าใหม่กลับไปยัง MyBigpoint
    } catch (error) {
      console.error("Failed to update user settings", error);
      const rollbackValue = !newLayout;
      localStorage.setItem("seniorLayout", rollbackValue ? "true" : "false");

      onChangeSeniorLayout(rollbackValue);
    }
  };

  const updateCurrentUser = async (payload) => {
    const clientAuth = process.env.REACT_APP_CLIENT_AUTH;
    const headers = {
      Authorization: `Bearer ${authToken}`,
      "X-Client-Auth": clientAuth,
      "x-user-id": userId,
      "Accept-Language": i18n.language.toUpperCase(),
    };

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}/api/users/current`,
        payload,
        { headers }
      );
      return response.data;
    } catch (error) {
      console.error("Failed to update user settings", error);
      throw error;
    }
  };

  return (
    <div
      className="w-26 h-10 p-1 rounded-full cursor-pointer"
      onClick={toggleSeniorLayout}
    >
      <div
        className={`w-full flex justify-center items-center gap-x-1 text-lg font-normal cursor-pointer w-15 p-1 rounded-full bg-primary-dark text-primary-text-dark pr-3 pl-3 h-9
    ${
      !seniorLayout
        ? "before:bg-secondary-text-invert"
        : "after:bg-secondary-text-invert"
    }
    `}
      >
        <span
          className={`text-base font-medium pt-0.5 ${
            !seniorLayout ? "text-secondary-text-invert" : ""
          }`}
        >
          {t("screen_size_text")}
        </span>
        <span className="text-lg font-thin">|</span>
        <span
          className={`text-22 font-semibold pb-0.5 ${
            seniorLayout ? "text-secondary-text-invert" : ""
          }`}
        >
          {t("screen_size_text").toUpperCase()}
        </span>
      </div>
    </div>
  );
};

export default ScreenSizeBar;
